import { MQ_SMALL_ONLY, MQ_LARGE, MQ_MIDLARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { smallSquare } = IMAGE_SIZES;

const base = {
  fallbackDims: smallSquare,
  sourceSets: [
    {
      layoutWidth: { value: 75, units: 'px' },
      imageDims: smallSquare,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 75, units: 'px' },
      imageDims: smallSquare,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 180, units: 'px' },
      imageDims: smallSquare,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 96, units: 'px' },
      imageDims: smallSquare,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: MQ_MEDIUM,
      ratio: 1
    },
    {
      media: MQ_SMALL_ONLY,
      ratio: 1
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
